import React from "react";
import {
  Grid,
  Chip,
  Divider
} from "@mui/material";
import {
  SectionDescription
} from "../MainInfo";

class ProductDescription extends React.PureComponent {

  onChangeForm = (locale, name, value) => {
    let values = {...this.props.values};
    values[locale][name] = value;
    this.props.onChange(values);
  }

  render () {
    const {
      values
    } = this.props;

    return (
      <Grid container spacing={1}>

        {/* RU */}
        <Grid item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="RU"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['ru']['description']}
            title="Полное описание"
            onChange={this.onChangeForm.bind(this, 'ru', 'description')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['ru']['short_description']}
            title="Краткое описание"
            onChange={this.onChangeForm.bind(this, 'ru', 'short_description')}
          />
        </Grid>

        {/* EN */}
        <Grid mt={3} item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="EN"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['en']['description']}
            title="Полное описание"
            onChange={this.onChangeForm.bind(this, 'en', 'description')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['en']['short_description']}
            title="Краткое описание"
            onChange={this.onChangeForm.bind(this, 'en', 'short_description')}
          />
        </Grid>

        {/* KAZ */}
        <Grid mt={3} item xs={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Chip label="KAZ"/>
            </Grid>
            <Grid item sx={{flex: 1}}>
              <Divider sx={{borderBottomWidth: "2px", borderColor: "rgba(0,0,0,0.08)"}}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['kaz']['description']}
            title="Полное описание"
            onChange={this.onChangeForm.bind(this, 'kaz', 'description')}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionDescription
            value={values['kaz']['short_description']}
            title="Краткое описание"
            onChange={this.onChangeForm.bind(this, 'kaz', 'short_description')}
          />
        </Grid>
      </Grid>
    )
  }
}

export default ProductDescription
